import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row">
      <div className="lg:w-1/2 h-[280px] md:h-[380px] relative overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20room%20with%20vintage%20camera%20equipment%20and%20red%20ambient%20lighting%2C%20anonymous%20whistleblower%20atmosphere%2C%20cinematic%20noir%20photography%2C%20dramatic%20shadows%2C%20investigative%20journalism%20theme%2C%20dark%20red%20and%20charcoal%20color%20palette%2C%20mysterious%20and%20tense%20mood&width=960&height=760&seq=cta-left-bg&orientation=landscape"
          alt="安全匿名爆料 - 17吃瓜"
          className="absolute inset-0 w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-background-950/60"></div>
        <div className="relative z-10 h-full flex flex-col justify-between p-8 md:p-12">
          <span className="text-secondary-300 text-xs tracking-wider self-start">
            安全匿名爆料
          </span>
          <div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 leading-tight">
              你的声音
              <br />
              值得被听见
            </h2>
          </div>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-950 flex items-center justify-center py-10 md:py-14 px-8">
        <div className="text-center max-w-md">
          <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 leading-tight mb-6">
            有料就爆
            <br />
            不怕事大
          </h2>
          <p className="text-secondary-400 text-sm leading-relaxed mb-8">
            17吃瓜承诺对所有爆料人信息严格保密。
            无论是网红黑料、明星塌房还是行业黑幕，
            你的每一个爆料都可能引爆全网。采用端到端加密，
            确保你的隐私安全无忧。
          </p>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 bg-primary-500 text-foreground-50 font-semibold text-sm px-8 py-3.5 rounded-full cursor-pointer hover:bg-primary-400 transition-all whitespace-nowrap"
          >
            匿名爆料通道
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}